module.exports = function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_forceReduced.js
// module id = 378
// module chunks = 35783957827783 114276838955818